import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { EncuestaDTO, PreguntaDTO } from "@DTOS";
import { MarcadorSeleccionado } from "@shared/clases";
import { OrdenamientosRespuestasEnum } from "@shared/enums";
import { ColumnasMostrar } from "./vista-datos/ColumnasMostrar";

export enum VistaMostrada { GRAFICO, TABLA }

@Injectable({
    providedIn: "root"
})
export class CambiosGraficosService {
    public indexPreguntaSeleccionada: BehaviorSubject<number> = new BehaviorSubject(0);
    public vistaMostrada: BehaviorSubject<VistaMostrada> = new BehaviorSubject(VistaMostrada.GRAFICO);
    public encuestaSeleccionada: BehaviorSubject<EncuestaDTO> = new BehaviorSubject(new EncuestaDTO());
    public mostrarReferencia: Subject<boolean> = new Subject();
    public preguntaSeleccionada: BehaviorSubject<PreguntaDTO> = new BehaviorSubject(new PreguntaDTO());
    public mostrarColumnas: BehaviorSubject<ColumnasMostrar> = new BehaviorSubject(ColumnasMostrar.TODAS);
    public listaPreguntasColapsado: BehaviorSubject<boolean> = new BehaviorSubject(true);
    public abrirListadoOverlay: Subject<boolean> = new Subject();
    public marcadoresSeleccionados: BehaviorSubject<MarcadorSeleccionado[]> = new BehaviorSubject([]);
    public mostrarCuotas: Subject<boolean> = new Subject();

    public ordenarDatos$: Observable<OrdenamientosRespuestasEnum>;

    private _ordenarDatos$ = new BehaviorSubject<OrdenamientosRespuestasEnum>(OrdenamientosRespuestasEnum.NOMBRE);

    constructor() {
        this.ordenarDatos$ = this._ordenarDatos$.asObservable();
    }

    public ordernarDatos(ordenamiento: OrdenamientosRespuestasEnum): void {
        this._ordenarDatos$.next(ordenamiento);
    }

    public limpiar() {
        this.indexPreguntaSeleccionada.next(0);
        this.vistaMostrada.next(VistaMostrada.GRAFICO);
        this.encuestaSeleccionada.next(new EncuestaDTO());
        this.preguntaSeleccionada.next(new PreguntaDTO());
        this.marcadoresSeleccionados.next([]);
    }

    public agregarMarcadorSeleccionado(marcador: MarcadorSeleccionado) {
        const marcadoresSeleccionados = this.marcadoresSeleccionados.value;
        if (marcadoresSeleccionados.some(marcadorSeleccionado => marcadorSeleccionado.nombre === marcador.nombre)) {
            return;
        }
        this.marcadoresSeleccionados.next([...marcadoresSeleccionados, marcador]);
    }
}
